import {
  faBooks,
  faClipboardListCheck,
  faClock,
  faFilePen,
  faHandsHoldingHeart,
  faMessageSmile,
  faStamp,
} from '@fortawesome/pro-duotone-svg-icons'

import type { QuickLink } from '@/components/QuickLinks'

export const TUTOR_RESOURCES = [
  {
    title: 'Tutor Training',
    href: '/tutor/training',
    icon: faBooks,
    iconColor: 'primary.fg',
  },
  {
    title: 'Assessments',
    href: '/tutor/assessments',
    icon: faFilePen,
    iconColor: 'primary.fg',
  },
  {
    title: 'Volunteer Hours',
    href: '/tutor/volunteer-hours',
    icon: faClock,
    iconColor: 'primary.fg',
  },
  {
    title: 'Peer Review Sessions',
    href: '/tutor/peer-review',
    icon: faClipboardListCheck,
    iconColor: 'primary.fg',
  },
  {
    title: 'Review Certifications',
    href: '/certification/review',
    icon: faStamp,
    iconColor: 'primary.fg',
  },
  {
    title: 'My Feedback',
    href: '/tutor/feedback',
    icon: faMessageSmile,
    iconColor: 'primary.fg',
  },
  {
    title: 'Volunteer Hub',
    href: '/volunteer',
    icon: faHandsHoldingHeart,
    iconColor: 'primary.fg',
  },
] satisfies QuickLink[]
